import { useState } from 'react';
import YouTubePlayerDialog from './YouTubePlayerDialog';
import { getYouTubeVideoId } from '../../utils/youtube';

interface Props {
  songTitle: string;
  youtubeUrl: string;
  spotifyUrl: string;
}

export default function SetlistMediaLinks({ songTitle, youtubeUrl, spotifyUrl }: Props) {
  const [playingVideo, setPlayingVideo] = useState<{ id: string; title: string } | null>(null);
  const videoId = youtubeUrl ? getYouTubeVideoId(youtubeUrl) : null;

  return (
    <>
      <div className="flex flex-wrap items-center gap-2">
        {youtubeUrl && (videoId ? (
          <button
            type="button"
            aria-label={`Assistir ${songTitle} no YouTube`}
            onClick={() => setPlayingVideo({ id: videoId, title: songTitle })}
            className="inline-flex min-h-8 items-center gap-1.5 rounded-md border border-red-400/30 bg-red-500/10 px-2.5 text-xs font-medium text-red-200 transition-colors hover:border-red-400/60 hover:bg-red-500/20"
          >
            <i className="ri-youtube-fill text-sm" aria-hidden="true" />
            YouTube
          </button>
        ) : (
          <a
            href={youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-8 items-center gap-1.5 rounded-md border border-red-400/30 bg-red-500/10 px-2.5 text-xs font-medium text-red-200 transition-colors hover:border-red-400/60 hover:bg-red-500/20"
          >
            <i className="ri-youtube-fill text-sm" aria-hidden="true" />
            YouTube
          </a>
        ))}
        {spotifyUrl && (
          <a
            href={spotifyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-8 items-center gap-1.5 rounded-md border border-green-400/30 bg-green-500/10 px-2.5 text-xs font-medium text-green-200 transition-colors hover:border-green-400/60 hover:bg-green-500/20"
          >
            <i className="ri-spotify-fill text-sm" aria-hidden="true" />
            Spotify
          </a>
        )}
      </div>
      {playingVideo && (
        <YouTubePlayerDialog
          videoId={playingVideo.id}
          songTitle={playingVideo.title}
          onClose={() => setPlayingVideo(null)}
        />
      )}
    </>
  );
}